export const setupDevices = async () => {
  let devices, stream;
  // Get device list
  try {
    devices = await navigator.mediaDevices.enumerateDevices();
  } catch (error) {
    throw new Error("Failed to enumerate devices:", error);
  }

  // Request permissions
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: {
        width: { ideal: 1920 },
        height: { ideal: 1080 },
        frameRate: { ideal: 30 },
      },
      audio: true,
    });
  } catch (error) {
    throw new Error("Failed to get user media:", error);
  }

  return { devices, stream };
};
